import type { LatLng } from "leaflet"
import type { ReactElement } from "react"

import { MapDrawingControls } from ".."
import type { LegendItem } from "../../../redux"
import { LegendPanel, MapActionsPanel, MapZoomControls } from "../../molecules"

import "./map-viewer-controls.styles.scss"

export interface IMapViewerControlOptions {
  fullScreen?: boolean
  mapActions?: boolean
  zoomControls?: boolean
  drawingControls?: boolean
  disableTextTool?: boolean
  legend?: boolean
  disableLegendDrag?: boolean
  visible?: boolean
  ignoreResize?: boolean
  sharedProject?: boolean
}

export interface IMapViewerControlsProps {
  attachmentCount?: number
  corner: LatLng
  oppositeCorner: LatLng
  options?: IMapViewerControlOptions
  prefix?: string
  mapId?: string
  legendUrl?: string
  legendItems?: LegendItem[]
  projectTitle?: string
}

export function MapViewerControls(props: IMapViewerControlsProps): ReactElement {
  const { attachmentCount, corner, oppositeCorner, options, mapId, prefix, legendUrl, legendItems, projectTitle } =
    props

  function optionalToBoolean(option?: boolean): boolean {
    return option === undefined ? true : option
  }

  const fullScreen: boolean = optionalToBoolean(options?.fullScreen)
  const mapActions: boolean = optionalToBoolean(options?.mapActions)
  const zoomControls: boolean = optionalToBoolean(options?.zoomControls)
  const drawingControls: boolean = optionalToBoolean(options?.drawingControls)
  const legend: boolean = optionalToBoolean(options?.legend)
  const allVisible: boolean = optionalToBoolean(options?.visible)
  const disableText: boolean = options?.disableTextTool ? options.disableTextTool : false

  const sharedProject: boolean = optionalToBoolean(options?.sharedProject)

  return (
    <>
      {allVisible && (
        <>
          {mapActions && attachmentCount !== undefined && (
            <MapActionsPanel
              mapId={mapId}
              projectTitle={projectTitle}
              attachmentCount={attachmentCount}
              options={{ sharedProject }}
            />
          )}
          {mapId && (
            <MapZoomControls
              hidden={!zoomControls}
              mapId={mapId}
              corner={corner}
              oppositeCorner={oppositeCorner}
              fullscreenButton={fullScreen}
              ignoreResize={options?.ignoreResize}
            />
          )}
          {drawingControls && <MapDrawingControls disableText={disableText} />}
          {legend && mapId && (
            <LegendPanel
              prefix={prefix}
              mapId={mapId}
              legendImageUrl={legendUrl}
              legendItems={legendItems}
              disableDrag={options?.disableLegendDrag}
            />
          )}
        </>
      )}
    </>
  )
}
